import React, { useRef, useState, useEffect } from 'react';
import { FaFileSignature, FaSave, FaSyncAlt, FaPhotoVideo, FaTrashAlt, FaArrowAltCircleRight, FaArrowAltCircleLeft, FaFilePdf } from 'react-icons/fa';
import './formulario.css';
import API from "../../providers/api";
import { Row, Col, Card, CardBody, Spinner, Button, Modal, ModalBody } from "reactstrap"
import SignatureCanvas from 'react-signature-canvas'
import logo_enterate from '../../assets/img/logo_enterate.jpg'
import success from '../../assets/img/success.png'
import fail from '../../assets/img/fail.png'
import warning from '../../assets/img/warning.png'
import { alert } from '../../helpers/alert';
import Webcam from 'react-webcam'
import moment from 'moment'
import CanvasFile from "../CanvasFile";
import ContractPreview from "../../components/contratos/contratoPreview";
import ReactToPrint from 'react-to-print';
import { capitalizeWords } from '../../utils/formatters';

const logo = 'https://contrato.olan.com.co/validacion/contrato/static/media/logo.ad4491da.png'

const Formulario = () => {
    const contratoRef = useRef(null)   // ← ref para capturar el contrato
    const inputRef = useRef(null)
    const [modalLoading, setModalLoading] = useState(false);
    const formatCash = Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
    });
    const nombreMes = (mes) => {
        switch (mes) {
            case '01':
                return 'Enero';
            case '02':
                return 'Febrero';
            case '03':
                return 'Marzo';
            case '04':
                return 'Abril';
            case '05':
                return 'Mayo';
            case '06':
                return 'Junio';
            case '07':
                return 'Julio';
            case '08':
                return 'Agosto';
            case '09':
                return 'Septiembre';
            case '10':
                return 'Octubre';
            case '11':
                return 'Noviembre';
            case '12':
                return 'Diciembre';
            default:
                return '';
        }
    }
    const WebcamComponent = () => <Webcam />
    const videoConstraints = {
        width: 400,
        height: 225,
        facingMode: 'user',
    }

    const [picture, setPicture] = useState('')
    const webcamRef = React.useRef(null)
    const capture = React.useCallback(() => {
        const pictureSrc = webcamRef.current.getScreenshot()
        setPicture(pictureSrc)
        setBtnVerGuardar(true)
    })
    const [firmaCliente, setFirmaCliente] = useState('')
    const [idFirmaCliente, setIdFirmaCliente] = useState('')
    const [lugarFirmaCliente, setLugarFirmaCliente] = useState('')

    const [firmaProveedor, setFirmaProveedor] = useState('')
    const [idFirmaProveedor, setIdFirmaProveedor] = useState('')
    const [lugarFirmaProveedor, setLugarFirmaProveedor] = useState('')
    const [imgFirmaProveedor, setImgFirmaProveedor] = useState('')


    const [id, setId] = useState('')
    const [fechaContrato, setFechaContrato] = useState('')
    const [nombreInstitucion, setNombreInstitucion] = useState('')
    const [representanteLegal, setRepresentanteLegal] = useState('')
    const [documentoRepresentanteLegal, setDocumentoRepresentanteLegal] = useState('')
    const [modulos, setModulos] = useState([])
    const [cuotas, setCuotas] = useState([])
    const [pagoInicial, setPagoInicial] = useState('')
    const [valorContrato, setValorContrato] = useState('')
    const [totalCuotas, setTotalCuotas] = useState('')
    const [tipopago, setTipopago] = useState('')

    const [contrato, setContrato] = useState({})
    const [title, setTitle] = useState('')
    const [header, setHeader] = useState('')
    const [body, setBody] = useState('')
    const [idBody, setIDBody] = useState('')
    const [footer, setFooter] = useState('')

    const [viewForm, setViewForm] = useState(false)
    const [viewSign, setViewSign] = useState(true)
    const [sign, setSign] = useState('')
    const [signA, setSignA] = useState('')
    const [url, setUrl] = useState('')
    const [urlA, setUrlA] = useState('')
    const [loadingSave, setLoadingSave] = useState(false)
    const [resultSuccess, setResultSuccess] = useState(true)
    const [loadingInit, setLoadingInit] = useState(false)
    const [formSend, setFormSend] = useState(false)
    const [typeSignature, setTypeSignature] = useState(2)
    const [canvasMaker, setCanvasMaker] = useState(null);
    const [validateSignature, setValidateSignature] = useState(false);
    const [btnValSignature, setBtnValSignature] = useState(true);
    const [btnGetSignature, setBtnGetSignature] = useState(false);
    const [btnSave, setBtnSave] = useState(false);
    const [canvasArea, setCanvasArea] = useState(true);

    const [btnVerGuardar, setBtnVerGuardar] = useState(false)
    const [verFoto, setVerFoto] = useState(false)

    const [firtsStep, setFirtsStep] = useState(true)
    const [secondStep, setSecondStep] = useState(false)

    let canvasVal = null;
    let contextVal = null;
    const canvasSurface = useRef(null)
    useEffect(() => {
        const queryParameters = new URLSearchParams(window.location.search)
        const token = queryParameters.get("id")
        if(token != undefined){
            setId(token)
            API.validateForm(token)
            .then(data => data.json())
            .then(dataJson => {
                if (dataJson.status == true && dataJson.data.fecha_firma == null) {
                    console.log(body);
                    console.log(contrato);
                    const info = dataJson.data
                    console.log(info)
                    console.log(capitalizeWords(info.legal_nombre || info.info.cliente_nombre), "cliente_nombre");
                    setContrato(info)
                    setBody(info.documento_legal.html_snapshot)
                    setIDBody(info.documento_legal.id)
                    setTitle(info.titulo)
                    setViewForm(true)
                    canvasVal = canvasSurface.current;
                    console.log(canvasSurface, "canvasSurface");
                    console.log(canvasVal, "canvasVal");
                    setCanvasMaker(canvasVal)
                    setFirmaCliente(capitalizeWords(info.legal_nombre || info.cliente_nombre))
                    setIdFirmaCliente(info.legal_identificacion || info.cliente_nit)
                    setLugarFirmaCliente(`${info.cliente?.lugar_expedicion_municipio} (${info.cliente?.lugar_expedicion_departamento})`)
                    setFirmaProveedor(info.proveedor?.representante_nombre)
                    setIdFirmaProveedor(info.proveedor?.representante_identificacion)
                    setLugarFirmaProveedor(`${info.proveedor?.lugar_expedicion}`)
                    setImgFirmaProveedor(info.proveedor?.firma)
                    styleCanvas(capitalizeWords(info.legal_nombre || info.cliente_nombre))
                    canvasVal.width=canvasVal.width
                }else{
                    setViewForm(false)
                    setLoadingInit(true)
                    setResultSuccess(true)
                }
            })
            .catch((e) => {
                setViewForm(false)
                setLoadingInit(true)
                setResultSuccess(false)
                console.log("Error =>", e)
            })
        }
    }, [])

    const styleCanvas = (applicantcap) => {
        console.log(applicantcap, "applicantcap");
        if(canvasVal != null)
        {
            contextVal = canvasVal.getContext("2d");
            contextVal.fillStyle = "#000";
            contextVal.font = "50px Stalemate";
            contextVal.fillText(applicantcap, 40, 50);
            setSignA(canvasVal)
        }else{
            contextVal = canvasMaker.getContext("2d");
            contextVal.fillStyle = "#000";
            contextVal.font = "50px Stalemate";
            contextVal.fillText(applicantcap, 40, 50);
            setSignA(canvasMaker)
        }
    }

    const styleTryCanvas = () => {
        setValidateSignature(true)
        canvasMaker.width=canvasMaker.width
        styleCanvas(firmaCliente)
        setBtnValSignature(false)
        setBtnGetSignature(true)
        setBtnSave(false)
    }

    const handleClear = () => {
        sign.clear()
        setUrl('')
    }

    const handleGenerate = () => {
        setUrl(sign.getTrimmedCanvas().toDataURL('image/png'))
        setUrlA('')
    }

    const handleGenerateA = () => {
        if(!validateSignature)
            alert('Warning!', 'Validate your signature.', 'warning', 'Closed');
        setUrl('')
        setUrlA(signA.toDataURL('image/png'))
        setBtnValSignature(false)
        setBtnGetSignature(false)
        setCanvasArea(false)
        setSecondStep(true)
    }

    const handleSecondStep = () => {
        console.log(url, urlA);
        if(url.length == 0 && urlA.length == 0){
            alert('Advertencia!', 'El documento debe ser firmado para continuar.', 'warning', 'Closed');
            return
        }
        setFirtsStep(false)
        setSecondStep(true)
        setBtnVerGuardar(false)
    }

    const backFirtsStep = () => {
        setFirtsStep(true)
        setSecondStep(false)
        setPicture('')
        setCanvasArea(true)
        setBtnValSignature(true)
    }

    const handleSave = () => {
        if(!validateSignature)
            return alert('Advertencia!', 'Por favor valida tu firma.', 'warning', 'Closed');
        if(url == "" && urlA == "")
            return alert('Advertencia!', '¨Por favor, valida tu firma.', 'warning', 'Closed');
        if(picture == "")
            return alert('Advertencia!', 'Por favor toma una foto.', 'warning', 'Closed');
        setLoadingSave(true)
        API.saveForm(id, url != "" ? url : urlA != "" ? urlA : '', picture, contratoRef.current.outerHTML, idBody)
        .then(data => data.json())
        .then(dataJson => {
            if (dataJson.status == true) {
                setViewForm(false)
                setLoadingInit(false)
                setFormSend(true)
                alert('Success!', dataJson.message, 'success', 'Closed');
                setBtnValSignature(false)
                setBtnGetSignature(false)
                setBtnSave(false)
            }else{
                alert('Advertencia!', dataJson.message, 'warning', 'Closed');
            }
            setLoadingSave(false)
        })
        .catch((e) => {
            console.log("Error =>", e)
        })
    }

    const onchangeTypeSignature = (e) => {
        const value = e.target.value
        setTypeSignature(value)
        if(value == "1"){
            setUrl('')
        }
    }

    const renderHeader = () => {

        return (
        <div
            style={{
            //position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            /* minHeight: layout.header.height, */
            padding: "18px 34px 10px 34px",
            zIndex: 1,
            background:
                "linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(255,255,255,0.92) 100%)",
            }}
        >
            <div className='row mb-5'>
                <div className='col-lg-1'></div>
                <div className='col-lg-10 text-center'>
                    <a href="#">
                        <img style={{width:'100%',maxWidth:'300px'}} src={logo} className='logoWidth' />
                    </a>
                </div>
                <div className='col-lg-1'></div>
            </div>

            {(title) && (
            <div style={{ /* marginTop: layout.header.image ? 8 : 0, */ textAlign: "center" }}>
                {title ? (
                <div style={{ fontWeight: 800, fontSize: 18, color: "#111827" }}>
                    {title}
                </div>
                ) : null}
            </div>
            )}
        </div>
        );
    };

    const renderBody = () => {
        return (
            <div
                style={{
                    outline: "none",
                    border: "1.5px dashed #a78bfa",
                    borderRadius: 8,
                    padding: 12,
                    minHeight: 260,
                    background: "rgba(255,255,255,0.85)",
                    cursor: "text",
                    lineHeight: "inherit",
                    fontSize: "inherit",
                    color: "inherit",
                    transition: "border-color 0.2s, box-shadow 0.2s",
                }}
                dangerouslySetInnerHTML={{ __html: body }}
            />
        )
    }

    const renderFooter = () => {
        
        return (
        <div
            style={{
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 0,
           /*  minHeight: layout.footer.height, */
            padding: "8px 34px 18px 34px",
            zIndex: 1,
            background:
                "linear-gradient(0deg, rgba(255,255,255,0.98) 0%, rgba(255,255,255,0.92) 100%)",
            }}
        >
           
            {/* {(leftText || centerText || rightText) && (
            <div
                style={{
                display: "flex",
                justifyContent: "space-between",
                gap: 12,
                marginTop: layout.footer.image ? 8 : 0,
                borderTop: "1px solid #E5E7EB",
                paddingTop: 8,
                fontSize: 11,
                color: "#6B7280",
                }}
            >
                <div style={{ width: "33%" }}>{leftText}</div>
                <div style={{ width: "33%", textAlign: "center" }}>{centerText}</div>
                <div style={{ width: "33%", textAlign: "right" }}>{rightText}</div>
            </div>
            )} */}
        </div>
        );
    };

    const renderSignatureBlock = (page) => {
        return (
        <div
            style={{
            display: "flex",
            justifyContent: "space-between",
            gap: 24,
            }}
        >
            <div style={{ width: "48%", display: "flex", flexDirection: "column" }}>
                <div
                    style={{
                    display: "flex",
                    alignItems: "flex-end",
                    marginBottom: 6,
                    }}
                >
                    {true ? (
                        canvasArea ? <canvas width='600' ref={canvasSurface} height='100'></canvas> : url || urlA != '' ? <img src={url ? url : urlA ? urlA : ''} style={{maxWidth:'600px', maxHeight:'100px'}} /> : ''
                    ) : null}
                </div>
                <div style={{ borderTop: "1px solid #222", paddingTop: 6 }}>
                    <div style={{ fontWeight: 700 }}>{firmaCliente}</div>
                    <div>No. de Identificación: {idFirmaCliente} {/* de {lugarFirmaCliente} */}</div>
                </div>
            </div>

            <div style={{ width: "48%", display: "flex", flexDirection: "column" }}>
                <div
                    style={{
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "center",
                    marginBottom: 6,
                    }}
                >
                    {imgFirmaProveedor ? (
                    <img
                        src={imgFirmaProveedor}
                        alt="Firma proveedor"
                        style={{
                        maxWidth: 250,
                        objectFit: "contain",
                        display: "block",
                        }}
                    />
                    ) : <img
                        src={logo}
                        alt="Firma proveedor"
                        style={{
                        maxWidth: 220,
                        objectFit: "contain",
                        display: "block",
                        }}
                    />}
                </div>
                <div style={{ borderTop: "1px solid #222", paddingTop: 6 }}>
                    <div style={{ fontWeight: 700 }}>{firmaProveedor}</div>
                    <div>No. de Identificación: {idFirmaProveedor} de {lugarFirmaProveedor}</div>
                </div>
            </div>
        </div>
        );
    };

    return (
        <div className='flex-container'>
            <div>
                <Card style={{ opacity: '0.9' }}>
                    <CardBody>
                        <div ref={contratoRef}>
                            {renderHeader()}
                            {body && (
                                <div style={{
                                        padding: '10px',
                                        fontSize: '14px',
                                        lineHeight: '1.8',
                                        textAlign: 'justify'
                                    }}>
                                    <ContractPreview
                                        contrato={contrato}
                                        template={body}
                                    />
                                    {picture && (
                                    <div style={{
                                        textAlign: 'center',
                                        marginTop: '20px',
                                        marginBottom: '20px'
                                    }}>
                                        <h4>Fotografía del Firmante</h4>
                                        <img
                                            src={picture}
                                            alt="Foto del firmante"
                                            style={{
                                                maxWidth: '250px',
                                                border: '1px solid #ccc',
                                                padding: '5px'
                                            }}
                                        />
                                    </div>)}
                                    {renderFooter()}
                                    {renderSignatureBlock()}
                                </div>
                            )}
                        </div>
                    </CardBody>
                    {
                        viewForm ?
                            firtsStep ?
                            <CardBody>
                                <div className="step-box">
                                    {
                                        typeSignature == "2" ?
                                            <div >
                                                <div className='row'>
                                                    <div className='col-lg-1'></div>
                                                    <div className='col-lg-10 text-center'>
                                                        {
                                                            btnValSignature ?
                                                            <>
                                                                <label style={{fontWeight:'bold'}}>Paso 1: </label><br/>
                                                                <button className='btn btn-primary' onClick={styleTryCanvas}> <FaFileSignature size={15} /> Validar Firma</button>
                                                            </> : ''
                                                        }
                                                    </div>
                                                    <div className='col-lg-1'></div>
                                                </div>
                                                <br/>
                                                <div className='row'>
                                                    <div className='col-lg-1'></div>
                                                    <div className='col-lg-10 text-center'>
                                                        {
                                                            btnGetSignature ?
                                                            <>
                                                                <label style={{fontWeight:'bold'}}>Paso 2: </label><br/>
                                                                <button className='btn btn-danger' onClick={handleGenerateA}><FaFileSignature size={15} /> Obtener Firma</button>
                                                            </> : ''}
                                                    </div>
                                                    <div className='col-lg-1'></div>
                                                </div>
                                            </div>
                                        : ''
                                    }
                                    <br/>
                                    <div className='row mt-4 mb-4'>
                                        <div className='col-lg-1'></div>
                                        <div className='col-lg-10 text-center'>
                                            {
                                                secondStep &&
                                                <button className='btn btn-success' onClick={handleSecondStep}>Continuar al siguiente paso <FaArrowAltCircleRight size={15} /></button>
                                            }
                                        </div>
                                        <div className='col-lg-1'></div>
                                    </div>
                                </div>
                            </CardBody>
                            :
                            secondStep ?
                            <CardBody>
                                <div className="step-box">
                                    <Row className="mt-4">
                                        <Col>
                                            <h3>Validación de identidad para autenticidad del contrato</h3>
                                            <br/>
                                            Para finalizar, en este último paso es necesario que tomes una foto nítida y con suficiente luz y esta debe ser de frente.
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg="12 text-center">
                                            <label style={{fontWeight:'bold'}}>MI FOTO</label>
                                        </Col>
                                    </Row>
                                    <Row className='mt-3'>
                                        {/* <Col lg="6">
                                            <label style={{fontWeight:'bold'}}>Ejemplo</label>
                                            <img src= {imagenFoto} style={{width:'100%'}} />
                                        </Col>*/}
                                            {picture == '' ? (
                                                <Col lg="12">
                                                    <Webcam
                                                        audio={false}
                                                        height={225}
                                                        ref={webcamRef}
                                                        width="100%"
                                                        screenshotFormat="image/jpeg"
                                                        videoConstraints={videoConstraints}
                                                    />
                                                </Col>
                                                ) : (
                                                    <Col lg="12 text-center">
                                                        <img src={picture} style={{width:'100%',maxWidth:'500px'}} />
                                                    </Col>
                                            )}
                                            {picture != '' ? (
                                                <Col lg="12 text-center">
                                                    <button style={{width:'100%',maxWidth:'300px'}}
                                                        onClick={(e) => {
                                                        e.preventDefault()
                                                        setPicture('')
                                                        setBtnVerGuardar(false)
                                                        }}
                                                        className="btn btn-primary mt-3"
                                                    >
                                                        Tomar foto nuevamente <FaSyncAlt size={15} />
                                                    </button>
                                                </Col>
                                                ) : (
                                                    <Col lg="12 text-center">
                                                        <button style={{width:'100%',maxWidth:'300px'}}
                                                            onClick={(e) => {
                                                            e.preventDefault()
                                                            capture()
                                                            }}
                                                            className="btn btn-danger"
                                                        >
                                                            Capturar imagen <FaPhotoVideo size={20} />
                                                        </button>
                                                    </Col>
                                            )}
                                    </Row>
                                    <Row className='mt-2 mb-5'>
                                        <Col style={{textAlign:'center'}}>
                                        {
                                            loadingSave ?
                                            <><Spinner color='success' /><br/><b style={{color:'#198564'}}>Enviando información... Por favor, espere.</b></>
                                            : <>
                                                <button className='btn btn-dark' onClick={backFirtsStep}><FaArrowAltCircleLeft size={15} /> Regresar</button>
                                                {btnVerGuardar && <button className='btn btn-success' onClick={handleSave}>Guardar información <FaSave size={20} /> </button>}
                                                </>
                                        }
                                        </Col>
                                    </Row>
                                </div>
                            </CardBody>
                            : ''
                        :<div className='row mt-4 mb-5'>
                            <div className='col-lg-1'></div>
                            <div className='col-lg-10 text-center step-box'>
                                {
                                    loadingInit ?
                                        resultSuccess ?
                                            <p style={{fontSize:'14pt',fontWeight:'bold'}}><img src={warning} style={{width:'20%'}} /><br/>Esta información ya ha sido procesada</p>
                                        : <p style={{fontSize:'14pt',fontWeight:'bold'}}><img src={fail} style={{width:'20%'}} /><br/>Ha ocurrido algo y no fue posible continuar con el proceso</p>
                                    : formSend ?
                                            <>
                                                <p style={{fontSize:'14pt',fontWeight:'bold'}}><img src={success} style={{width:'20%'}} /><br/>Información procesada correctamente</p>
                                                <Row>
                                                    <Col lg="12 text-center mt-3 mb-4">
                                                        <ReactToPrint
                                                            trigger={() => (
                                                                <Button color="danger">
                                                                    Descargar contrato <FaFilePdf size={20} />
                                                                </Button>
                                                            )}
                                                            content={() => contratoRef.current}
                                                            documentTitle={`Validación de Contrato Olan Academic No. ${id}`}
                                                        />
                                                    </Col>
                                                </Row>
                                            </>
                                        : <Spinner color="success" />
                                }
                            </div>
                            <div className='col-lg-1'></div>
                        </div>
                    }
                </Card>
            </div>
            <Modal isOpen={modalLoading} size='sm'>
                <ModalBody>
                    <Row>
                        <Col className='text-center'>
                            El archivo PDF file se está generando, por favor espere...
                        </Col>
                    </Row>
                    <Row>
                        <Col className='text-center'>
                            <Spinner color='success' size={50} />
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
        </div>
    );
}

export default Formulario;